import { NavLink } from 'react-router-dom';
import { NAV } from '@/nav';
import { cn } from '@/lib/cn';
import { Fab } from './Fab';

const MOBILE = NAV.filter((n) => n.mobile); // Principal, Transações, Cartões, Mais (+ FAB central)

/** Bottom nav do mobile (<1024px): 4 itens + FAB "+" central elevado. */
export function BottomNav({ onFab }: { onFab?: (anchor: DOMRect) => void }) {
  const left = MOBILE.slice(0, 2);
  const right = MOBILE.slice(2);

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 flex h-[calc(4rem+env(safe-area-inset-bottom))] items-stretch border-t border-border bg-surface pb-[env(safe-area-inset-bottom)] lg:hidden">
      {left.map((item) => (
        <NavItemMobile key={item.to} {...item} />
      ))}

      <div className="relative flex w-full items-center justify-center">
        <div className="absolute -top-5">
          <Fab onClick={onFab} size="lg" />
        </div>
      </div>

      {right.map((item) => (
        <NavItemMobile key={item.to} {...item} />
      ))}
    </nav>
  );
}

function NavItemMobile({ to, label, icon: Icon }: (typeof MOBILE)[number]) {
  return (
    <NavLink
      to={to}
      end={to === '/'}
      className="flex w-full flex-col items-center justify-center gap-1 pt-1.5"
    >
      {({ isActive }) => (
        <>
          {/* Pill atrás do ícone deixa o item ativo óbvio e aumenta o alvo visual. */}
          <span
            className={cn(
              'grid h-8 w-14 place-items-center rounded-full transition-colors',
              isActive && 'bg-primary-weak',
            )}
          >
            <Icon
              className={cn('size-6 transition-colors', isActive ? 'text-primary' : 'text-muted')}
            />
          </span>
          <span
            className={cn(
              'text-[11px] font-medium leading-none transition-colors',
              isActive ? 'text-primary' : 'text-muted',
            )}
          >
            {label}
          </span>
        </>
      )}
    </NavLink>
  );
}
